import zh from './zh/common';

const resources = {
  zh: {
    common: zh,
  },
};

export default resources;